var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10C16.25 13.4518 13.4518 16.25 10 16.25M16.25 10C16.25 6.54822 13.4518 3.75 10 3.75M16.25 10H3.75M10 16.25C6.54822 16.25 3.75 13.4518 3.75 10M10 16.25C11.5633 14.5385 12.4517 12.3175 12.5 10C12.4517 7.68252 11.5633 5.46147 10 3.75M10 16.25C8.4367 14.5385 7.54828 12.3175 7.5 10C7.54828 7.68252 8.4367 5.46147 10 3.75M3.75 10C3.75 6.54822 6.54822 3.75 10 3.75",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/insight.0fea6620d6c88733e9f8c448371c6101.svg";
export { ForwardRef as ReactComponent };